module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/babel-runtime/core-js/object/assign.js
// module id = 939
// module chunks = 48 49 50